import createVueComponent from '../createVueComponent';

const Unlock = createVueComponent('UnlockIcon', [
  ['rect', { x: '3', y: '11', width: '18', height: '11', rx: '2', ry: '2' }],
  ['path', { d: 'M7 11V7a5 5 0 019.9-1' }],
]);

export default Unlock;
